<template>
  <div class="he-layout--items unselect">
    <div
      v-for="item in configs"
      :key="item.name"
      class="he-layout--items--panel"
    >
      <p class="he-layout--items--panel--label" v-text="item.label" />
      <draggable
        v-model="item.list"
        class="he-layout--items--panel--list"
        :group="{ name: 'HFormGroup', pull: 'clone', put: false }"
        :clone="clone"
        :sort="false"
        animation="300"
      >
        <div v-for="(i, index) in item.list" :key="i.name + index" class="he-layout--items--panel--list--li" v-text="i.label" />
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import _ from 'lodash'
export default {
  name: 'Items',
  components: { draggable },
  props: {
    configs: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    clone(obj) {
      const newObj = Object.assign(_.cloneDeep(obj), { fieldId: `${obj.name}_${new Date().getTime()}` })
      return newObj
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../index.scss';

.he-layout--items {
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  &--panel {
    box-sizing: border-box;
    padding: 10px 15px;
    padding-right: 0;
    margin-top: 20px;
    width: 100%;

    &--label {
      width: 100%;
      font-size: 16px;
      font-weight: 600;
    }

    &--list {
      width: 100%;
      margin-top: 10px;
      display: flex;
      flex-flow: row wrap;

      &--li {
        width: 100px;
        margin-right: 10px;
        margin-bottom: 10px;
        box-sizing: border-box;
        padding: 5px 10px;
        border: $border-gray;
        @include display-flex(row, nowrap, center, center);
        font-size: 14px;
        cursor: move;

        &:hover {
          background-color: rgba(0, 0, 0, .03);
        }
      }
    }
  }
}
</style>
